var path = 'areas/shared/views/selector/match-user.html';
var html = "<span ng-if=\"$item.Username == null\" class=deleted uib-tooltip=\"The user referenced by this record ({{$item}}) no longer exists and should be removed before saving. Please let Octopus support know so that we can prevent this from happening in future.\"><i class=\"fa fa-warning\"></i> Missing</span> <span ng-if=\"$item.Username != null\">{{$item.DisplayName}} ({{$item.Username}})</span> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/match-user.html
// module id = 4965650894161193
// module chunks = 1